// removed by extract-text-webpack-plugin
module.exports = {"playButton":"src-components-SnapPhone----SnapPhone-module---playButton---2B2Cv","snapContainer":"src-components-SnapPhone----SnapPhone-module---snapContainer---1R4IU","videoContainer":"src-components-SnapPhone----SnapPhone-module---videoContainer---3aoK7","isPlaying":"src-components-SnapPhone----SnapPhone-module---isPlaying---Bifi9","phoneMockup":"src-components-SnapPhone----SnapPhone-module---phoneMockup---2Fh9W"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SnapPhone/SnapPhone.module.less
// module id = 344
// module chunks = 153596302435155